module.exports = __webpack_public_path__ + "static/media/nfl_app_scraper_web.a9d6d79b.PNG";